import axios from "axios";
import { toast } from "react-toastify";
import * as actions from "../api";

const api =
  ({ dispatch }) =>
  (next) =>
  async (action) => {
    if (action.type !== actions.apiCallBegan.type) return next(action);

    const {
      serviceUrl,
      url,
      method,
      data,
      onStart,
      onSuccess,
      onError,
      considerPayloads,
      onStartPayload,
      onSuccessPayload,
      onErrorPayload,
      responseType,
      params,
    } = action.payload;

    if (considerPayloads) {
      if (onStart) dispatch({ type: onStart, payload: onStartPayload });
    } else {
      if (onStart) dispatch({ type: onStart });
    }

    next(action);

    try {
      let requestObject = {
        headers: { "x-auth-token": localStorage.getItem("jwt") },
        baseURL: serviceUrl,
        url,
        method,
        data,
      };

      if (responseType) requestObject.responseType = responseType;
      if (params) requestObject.params = params;

      const response = await axios.request(requestObject);

      // General
      dispatch(actions.apiCallSuccess(response.data));
      // Specific
      if (considerPayloads) {
        if (onSuccess)
          dispatch({
            type: onSuccess,
            payload: {
              response: response.data,
              extras: onSuccessPayload,
              fullresponse: responseType ? response : response, // {},
            },
          });
      } else {
        if (onSuccess) dispatch({ type: onSuccess, payload: response.data });
      }
    } catch (error) {
      // General
      dispatch(actions.apiCallFailed(error.message));
      // Specific
      if (considerPayloads) {
        if (onError)
          dispatch({
            type: onError,
            payload: { response: error.message, extras: onErrorPayload },
          });
        toast.error(
          "Failed to call. Here is the message from server: " + error.message
        );
      } else if (onError) {
        dispatch({
          type: onError,
          payload: error?.response?.data,
        });
      } else {
        if (onError)
          dispatch({
            type: onError,
            payload: error.message,
          });
      }
    }
  };

export default api;
